import {Action} from '@ngrx/store';
import {ReactionApiModel} from '../../api/models/reaction.api.model';
import {SocialListType} from '../../shared/modal/components/social-list/social-list-type.type';

export enum ReactionListActionTypes {
  SEED_PAGE = '[ReactionList] Seed Page',
  LOAD_PAGE = '[ReactionList] Load Page',
  LOAD_PAGE_SUCCESS = '[ReactionList] Load Page Success',
  LOAD_PAGE_ERROR = '[ReactionList] Load Page Error',
  ADD_REACTION_TO_LIST = '[ReactionList] Add Reaction To List',
  REMOVE_REACTION_FROM_LIST = '[ReactionList] Remove Reaction From List'
}

export class SeedPage implements Action {
  readonly type = ReactionListActionTypes.SEED_PAGE;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public page: number,
    public reactions: ReactionApiModel[],
    public hasMore: boolean,
    public loadedAt: number = Date.now()
  ) {
  }
}

export class LoadPage implements Action {
  readonly type = ReactionListActionTypes.LOAD_PAGE;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public page: number
  ) {
  }
}

export class LoadPageSuccess implements Action {
  readonly type = ReactionListActionTypes.LOAD_PAGE_SUCCESS;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public page: number,
    public reactions: ReactionApiModel[],
    public hasMore: boolean,
    public loadedAt: number = Date.now()
  ) {
  }
}

export class LoadPageError implements Action {
  readonly type = ReactionListActionTypes.LOAD_PAGE_ERROR;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public page: number
  ) {
  }
}

export class AddReactionToList implements Action {
  readonly type = ReactionListActionTypes.ADD_REACTION_TO_LIST;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public reaction: ReactionApiModel
  ) {
  }
}

export class RemoveReactionFromList implements Action {
  readonly type = ReactionListActionTypes.REMOVE_REACTION_FROM_LIST;

  constructor(
    public listType: SocialListType,
    public subjectId: string,
    public reactionId: string
  ) {
  }
}

export type Actions =
  | SeedPage
  | LoadPage
  | LoadPageSuccess
  | LoadPageError
  | AddReactionToList
  | RemoveReactionFromList;

